
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';

import Sphere from '../../resources/sphere.png';

import SpeciaLogo2 from '../../resources/circle specia 2.png';

import DownButton from '../../resources/DownButton.png';

import IsoLogo from '../../resources/isoLogo.png';

import SecurityImg from '../../resources/Security.png';

import SpeciaLogoWithName from '../../resources/SpeciaLogoWithName.svg';

import TeamLogo from '../../resources/chart.png';

import Cookies from 'universal-cookie';

import { ButtonBase, Button } from '@mui/material';

export default () => {
  const navigate = useNavigate();

  const auth = useAuth();

  const [
    searchParams,
    setSearchParams,
  ] = useSearchParams();
  const token = searchParams.get('token');

  const [
    status,
    setStatus,
  ] = useState(200);

  const [
    loading,
    setLoading,
  ] = useState(false);

  const cookies = new Cookies();

  const currentPath = cookies.get('currentPath') || '/';

  useEffect(() => {
    if (auth.isAuthenticated) {
      console.log(currentPath);
      navigate(currentPath);
    }
  }, [auth.isAuthenticated]);

  return (
    <>

      <div style={{ display: 'flex', flexDirection: 'column', width: '100%', padding: '0', textAlign: 'center', alignItems: 'center' }}>
        <div style={{ width: '100%', padding: '1vw 1vw', paddingBottom: '4vw', backgroundRepeat: 'no-repeat', backgroundSize: 'cover',
          //  'backgroundImage': `linear-gradient(180deg, rgb(255, 255, 255, 0) 0%, rgba(34,16,65, 1) 100%), linear-gradient(245deg, rgb(17, 10, 34, 0) 0px, rgb(19, 11, 38, 0.95) 100%, rgb(32, 10, 43, 1) 50%), linear-gradient(90deg, rgb(17, 10, 34, 0) 0px, rgb(19, 11, 38, 0.95) 100%, rgb(32, 10, 43, 1) 100%), linear-gradient(0deg, rgb(17, 10, 34, 0) 0px, rgb(34,16,65, 0.9) 100%, rgb(32, 10, 43, 1) 100%), url("${BGD}")`
        }}
        >

          <div style={{ color: 'rgb(255, 255, 255)', marginTop: '1vw', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '5vw 0', backgroundColor: `#39887F`, borderRadius: '0.5vw' }}>
            <img src={Sphere} style={{ width: '6vw', marginLeft: '0', borderBottom: 'solid 0.15vw rgb(255, 255, 255, 0.5)', marginBottom: '2vw', paddingBottom: '2vw', paddingLeft: '1.5vw', paddingRight: '1.5vw' }} />
            {/* <p style={{fontSize: '2.8vw', fontWeight: '300', letterSpacing: '0.05vw'}}>Powerful tool for accountants.</p> */}
            <p style={{ fontWeight: '300', fontSize: '2.5vw', width: '47vw', marginTop: '0.5vw', lineHeight: '1.8vw', letterSpacing: '0.05vw' }}>
              Faster. Smarter. Accurate.
            </p>
            <p style={{ fontWeight: '300', fontSize: '0.9vw', width: '60vw', marginTop: '3vw', lineHeight: '1.8vw' }}>
              Specia Accountant is a cloud-based platform designed to streamline and enhance tax reporting for accountants. Leveraging advanced AI technology, it automates ATO report preparation and integrates seamlessly with accounting software, reducing time spent on repetitive tasks and improving accuracy.
            </p>

            <ButtonBase style={{ borderRadius: '10vw', marginTop: '2vw', color: '#1c6c6c' }}><img src={DownButton} style={{ width: '3vw' }} /></ButtonBase>

          </div>
        </div>

        <div style={{ width: '100%', padding: '0 6vw' }}>
          <span style={{ fontSize: '0.9vw', padding: '0.2vw 0.7vw', border: 'solid 0.08vw rgb(0, 0, 0, 0.9)', borderRadius: '10vw', backgroundColor: 'rgb(255, 255, 255, 0.5)' }}>Custom Agent Solutions</span>
          <p style={{ marginTop: '3vw', fontSize: '2.3vw', fontWeight: '300' }}>More time for what matters.</p>

          <div style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', backgroundColor: 'rgb(255, 255, 255, 0.6)', marginTop: '5vw', borderRadius: '1vw' }}>
            <div style={{ display: 'flex', flexDirection: 'row', backgroundColor: 'rgb(255, 255, 255, 0.025)', padding: '2vw', borderRadius: '1vw', alignItems: 'center' }}>
              <div style={{ flex: 2 }}>
                <img src={TeamLogo} width="100%" style={{ padding: '3vw' }} />
              </div>

              <div style={{ textAlign: 'left', padding: '1.5vw', flex: 5, paddingLeft: '2vw' }}>
                <p style={{ fontSize: '1.7vw', fontWeight: '300' }}>Choosing Specia Accountant</p>
                <p style={{ fontSize: '0.9vw', lineHeight: '1.6vw', fontWeight: '300' }}>Specia Accountant is an AI-powered, cloud-based platform designed for accountants to streamline tax reporting and optimize workflows. With seamless integration to ATO, Xero, and MYOB, it automates tedious tasks, saving time and reducing costs. By enhancing client satisfaction and freeing up capacity, Specia Accountant not only drives immediate efficiency but also supports long-term business growth. Elevate your tax management process with a solution that’s precise, scalable, and built to transform the way you work.</p>

                <Button
                  onClick={() => { auth.signinRedirect(); }}
                  variant="outlined"
                  style={{ flex: 1, marginRight: '1vw', marginTop: '1.5vw', marginBottom: '2vw',
                    borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.4vw 1.2vw', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#39887F, #39887F)', borderRadius: '0.4vw', textTransform: 'none', fontSize: '0.9vw', fontWeight: 500, letterSpacing: '0.06vw',
                  }}
                >
                  Learn more
                </Button>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <div style={{ flex: 1, marginRight: '1vw' }}>
                    <p style={{ fontSize: '0.9vw', fontWeight: '600', marginBottom: '0.3vw' }}>Integration</p>
                    <p style={{ fontSize: '0.8vw' }}>Connect ATO, Xero, and MYOB seamlessly.</p>
                  </div>
                  <div style={{ flex: 1, marginRight: '1vw' }}>
                    <p style={{ fontSize: '0.9vw', fontWeight: '600', marginBottom: '0.3vw' }}>Automation</p>
                    <p style={{ fontSize: '0.8vw' }}>AI-driven tasks for faster reporting.</p>
                  </div>
                  <div style={{ flex: 1, marginRight: '1vw' }}>
                    <p style={{ fontSize: '0.9vw', fontWeight: '600', marginBottom: '0.3vw' }}>Time</p>
                    <p style={{ fontSize: '0.8vw' }}>Minimize manual work, maximize efficiency.</p>
                  </div>
                  <div style={{ flex: 1, marginRight: '1vw' }}>
                    <p style={{ fontSize: '0.9vw', fontWeight: '600', marginBottom: '0.3vw' }}>Savings</p>
                    <p style={{ fontSize: '0.8vw' }}>Reduce costs with streamlined processes.</p>
                  </div>
                  <div style={{ flex: 1, marginRight: '1vw' }}>
                    <p style={{ fontSize: '0.9vw', fontWeight: '600', marginBottom: '0.3vw' }}>Satisfaction</p>
                    <p style={{ fontSize: '0.8vw' }}>Improve client trust and results.</p>
                  </div>

                </div>
              </div>

            </div>
          </div>

          <div style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', padding: '5vw 0' }}>
            <div style={{ display: 'flex', flexDirection: 'row', borderRadius: '1vw', alignItems: 'center' }}>

              <div style={{ textAlign: 'left', flex: 2, paddingRight: '4vw', paddingLeft: '1vw' }}>
                <p style={{ fontSize: '2.1vw', fontWeight: '300', marginBottom: '2vw' }}>Efficiency</p>

                <p style={{ fontSize: '1.1vw', fontWeight: '400' }}>Save Time and Reduce Costs with Automated Workflows and Efficient Tax Management</p>
                <p style={{ fontSize: '0.9vw', lineHeight: '1.6vw', fontWeight: '300' }}>Specia Accountant helps accountants optimize their workflow by automating repetitive tax tasks, reducing manual labor, and streamlining reporting processes. With advanced AI technology, our platform minimizes time spent on data entry, calculations, and compliance checks, while also lowering operational costs. By enhancing accuracy and efficiency, Specia Accountant allows you to focus on high-value tasks, driving both time and cost savings for your practice.</p>

              </div>
              <div style={{ width: '10vw', flex: 2, textAlign: 'right', borderRadius: '1vw' }}>
                <img style={{ width: '100%', height: '27vw', borderRadius: '1vw' }} src="https://specia.ai/wp-content/uploads/2021/11/icons8-team-yTwXpLO5HAA-unsplash.jpg" />
              </div>
            </div>
          </div>

          <div style={{ marginTop: '2vw', width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', padding: '0', margin: '5vw 0', backgroundColor: 'rgb(255, 255, 255, 0.6)', borderRadius: '1vw' }}>
            <div style={{ display: 'flex', flexDirection: 'row', backgroundColor: 'rgb(255, 255, 255, 0.025)', padding: '2vw', borderRadius: '1vw', alignItems: 'center' }}>
              <div style={{ flex: 2 }}>
                <img src={SpeciaLogo2} width="100%" style={{ padding: '3vw', objectFit: 'cover' }} />
              </div>

              <div style={{ textAlign: 'left', padding: '1.5vw', flex: 5, paddingLeft: '2vw' }}>
                <p style={{ fontSize: '1.7vw', fontWeight: '300' }}>Experience Effortless Tax Management with Powerful Integrations to ATO, Xero, and MYOB</p>
                <p style={{ fontSize: '0.9vw', lineHeight: '1.6vw', fontWeight: '300' }}>Specia Accountant connects seamlessly with ATO, Xero, and MYOB, giving accountants a unified platform for streamlined tax reporting and compliance. With real-time data syncing and reliable API integrations, our platform automates workflows across the tools you already use, ensuring accuracy, efficiency, and up-to-date reporting. Eliminate manual data entry and discover a fully connected solution for all your tax needs.</p>
              </div>
              <div style={{ width: '10vw', flex: 2 }}>
                <Button
                  onClick={() => { auth.signinRedirect(); }}
                  variant="outlined"
                  style={{ flex: 1, marginRight: '1vw', marginTop: '1.5vw', marginBottom: '2vw',
                    borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.4vw 1.2vw', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#39887F, #39887F)', borderRadius: '0.4vw', textTransform: 'none', fontSize: '0.9vw', fontWeight: 500, letterSpacing: '0.06vw',
                  }}
                >
                  Try now
                </Button>
              </div>
            </div>
          </div>

          <div style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', padding: '5vw 0' }}>
            <div style={{ display: 'flex', flexDirection: 'row', borderRadius: '1vw', alignItems: 'center' }}>

              <div style={{ width: '10vw', flex: 2, textAlign: 'right', borderRadius: '1vw' }}>
                <img style={{ width: '100%', height: '27vw', borderRadius: '1vw', objectFit: 'cover' }} src={SecurityImg} />
              </div>
              <div style={{ textAlign: 'left', flex: 2, paddingLeft: '4vw', paddingRight: '1vw' }}>
                <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '2vw' }}>
                  <p style={{ fontSize: '2.1vw', fontWeight: '300', flex: 1, marginBottom: '0' }}>Data Security</p>

                </div>

                <p style={{ fontSize: '1.1vw', fontWeight: '400' }}>Advanced Security Features Ensure Your Data is Encrypted, Private, and Fully Protected at All Times</p>
                <p style={{ fontSize: '0.9vw', lineHeight: '1.6vw', fontWeight: '300' }}>Specia Accountant prioritizes the security and confidentiality of your data with industry-leading encryption, multi-factor authentication, and regular compliance audits. Our platform is built with advanced security protocols to safeguard sensitive tax information and ensure that your data remains private and protected at all times. With Specia Accountant, you can focus on your work, knowing that your data is secure against threats and fully compliant with the highest standards of data protection.</p>
                <img src={IsoLogo} style={{ width: '15vw', height: '4vw', marginTop: '1vw' }} />
              </div>

            </div>
          </div>
        </div>
        <div className="col-md-12">

        </div>

      </div>
    </>
  );
};

